import './assets/scss/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { instanceI18n } from '@/plugins/i18n'
import {
  installSipWebSocketLifecycle,
  setSipWebSocketsBlocked,
} from '@/helpers/sip-websocket-lifecycle.helper'
import { createHead } from '@unhead/vue/client'
import { ConfirmationService, ToastService, Config, Tooltip, Ripple } from 'primevue'
import { AppTheme } from './theme/app-theme'

installSipWebSocketLifecycle()
setSipWebSocketsBlocked(!localStorage.getItem('tokenHub'))

const app = createApp(App)
const head = createHead()

app.use(createPinia())
app.use(router)
app.use(instanceI18n)
app.use(head)

app.use(Config, {
  theme: {
    preset: AppTheme,
    options: {
      prefix: 'p',
      darkModeSelector: '.dark',
    },
  },
})

app.use(ToastService)
app.use(ConfirmationService)
app.directive('tooltip', Tooltip)
app.directive('ripple', Ripple)

app.mount('#app')
